import React, { useEffect, useRef, useState  } from 'react'
import { DropTarget } from 'react-drag-drop-container';
import gsap from "gsap";
import _, { map } from 'underscore';
import CharAbs from './CharAbs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faFaceSadCry } from '@fortawesome/free-solid-svg-icons'
import { Dialog } from './Dialog';
import { faFaceSurprise } from '@fortawesome/free-regular-svg-icons';
import { Mascota } from './Mascota';

export const Board = ({c, totalCorrectas, ejercicio, avanzarEj}) => {

    
    const [stars, setStars] = useState([]);
    const [errorIcons, setErrorIcons] = useState([]);
    const [errorVisible, setErrorVisible] = useState(false);
    const [items, setItems] = useState([]);
    const [dialog, setDialog] = useState({text:'', type:'', open:false});
    const [mascota, setMascota]=useState({image:`${process.env.PUBLIC_URL}/assets/perro.png`, x:20, reflected:false, visible:false});
    const correctas = useRef(0);


/*--------- -----------*/
const makeStars = () =>{
    const numberOfStars = 20;
    const starsArr = [...Array(numberOfStars)].map((el, i) => ( 
       <FontAwesomeIcon key={`star-${i}`} icon={faStar} className="starInstance" />
    ));
    if(stars.length>0){
        setStars([]);
    }
    setStars(starsArr);
    animateBlobs();
}


const triggerError = () =>{
    const numberOfErrorIcons = 1;
    const errorIconsArray = [...Array(numberOfErrorIcons)].map((el, i) => ( 
        <FontAwesomeIcon key={`face-${i}`} icon={faFaceSurprise} className="errorInstance" />
     ));
    
    if(errorIcons.length>0){
        setErrorIcons([]);
    }
    setErrorIcons(errorIconsArray);
    animateErrorIcons();
}



	
function animateBlobs() {
	
	let xSeed = _.random(350, 380);
	let ySeed = _.random(120, 170);

    const stars = document.querySelectorAll('.starInstance');
    let i = 0
    
    while (i < stars.length) {
        let $blob = stars[i];
		let speed = _.random(1, 5);
		let rotation = _.random(5, 100);
		let scale = _.random(0.8, 1.5);
		let x = _.random(-xSeed, xSeed);
		let y = _.random(-ySeed, ySeed);

		gsap.to($blob, speed, {
			x: x,
			y: y,
			ease: "power1.easeOut",
			opacity: 0,
			rotation: rotation,
			scale: scale,
			onStartParams: [$blob],
			onStart: function($element) {
				$element.style.display="block"
			},
			onCompleteParams: [$blob],
			onComplete: function($element) {
				$element.style.display="none"
			}
		});

        i++;
    }
    
}

function animateErrorIcons() {
	
	let xSeed = _.random(350, 380);
	let ySeed = _.random(120, 170);

    const errorIconsArr = document.querySelectorAll('.errorInstance');
    let i = 0
    
    while (i < errorIconsArr.length) {
        let $blob = errorIconsArr[i];
		let speed = _.random(1, 5);
		let rotation = _.random(5, 100);
		let scale = _.random(0.8, 1.5);
		let x = _.random(-xSeed, xSeed);
		let y = _.random(-ySeed, ySeed);

		gsap.to($blob, speed, {
			x: x,
			y: y,
			ease: "power1.easeOut",
			opacity: 0,
			rotation: rotation,
			scale: scale,
			onStartParams: [$blob],
			onStart: function($element) {
				$element.style.display="block"
			},
			onCompleteParams: [$blob],
			onComplete: function($element) {
				$element.style.display="none"
			}
		});

        i++;
    }
    
}


const showDialog =(txt, type='success' )=>{
    setDialog({text:txt, type:type, open:true});
}

const closeDialog=(e) =>{
        setItems([]);
        setDialog({text:'', type:'', open:false})
        avanzarEj(e);
        correctas.current=0;
}



const showErrorMsg = ()=>{
    setErrorVisible(true);
    

    let  errorTimer = setTimeout(function(){
        setErrorVisible(false);    
    }, 5000);
    if(errorVisible){clearTimeout(errorTimer)};
   
    
}

/*--------------------*/

    const handleDrop = (e) => {
        
        if(e.dragData.res){
            makeStars();
            setItems([...items,e.dragData]);
            e.containerElem.style.visibility="hidden";
            correctas.current++;
            
            if(totalCorrectas === correctas.current){
                setMascota({...ejercicio.mascota, visible:true});
                setTimeout(()=>{
                    showDialog(ejercicio.exito,'success');
                },2500);
               
            }
        }else{
            showErrorMsg();
            triggerError();
        }
    };

    useEffect(() => {
        let mounted = true;
        if(mounted){
            setMascota(ejercicio.mascota);
            setDialog({text:'', type:'', open:false})
        };
    
      return () => {
        mounted=false;
      }
    }, [ejercicio]);
    

    return (
        <div id="board" className={`e${c}`}>
            <h1>{c}</h1>
            <div className="dropWrapper">
                <img className={'fondo'} alt="foto" src={`${process.env.PUBLIC_URL}/assets/Familia-${c}.jpg`} />
                <div className="dropBox" id="dropBox">
                    <DropTarget
                        onHit={handleDrop}
                        targetKey="boardArea"
                        dragData={"limpio"}
                    >
                    {items?.map((item) => (
                        <CharAbs key={item.id} item={item} targetKey="boardArea" />
                    ))}
                    </DropTarget>
                    {(errorVisible)&&<div className="errorFlag">{ejercicio.fracaso}</div>}
                    {(mascota?.visible)&&<Mascota mascota={mascota}/>}
                </div>
                {stars}
                {errorIcons}
                {(dialog.open)&&<Dialog mensaje={dialog.text} type={dialog.type} closeDialog={closeDialog}/>}
            </div>
            
        </div>
    )
}



export default Board;